import { useRef, useState } from "react";
import { toast } from "sonner";
import { Check, FileText } from "lucide-react";
import api, { API, apiErr } from "@/lib/api";
import { makeForm } from "@/lib/upload";
import { isNa, ownerOf, plainName } from "@/lib/docReasons";
import { useAuth } from "@/context/AuthContext";

const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

// Processo escriturado/arquivado: só o arquivo, sem pedidos nem alertas. Verificados primeiro; o que falta a cinzento.
export function ArchiveZone({ pid, p, docs, onChange }) {
  const label = (d) => <>{cap(plainName(d))} <span className="text-slate-500 text-sm">· {ownerOf(d, p).label}</span></>;
  const ro = useAuth().user?.role === "direccao";
  const fileRef = useRef(null);
  const [pickKey, setPickKey] = useState(null);
  const kept = docs.filter((d) => d.status === "recebido" && !isNa(d))
    .sort((a, b) => (b.verdict === "validado") - (a.verdict === "validado"));
  const absent = docs.filter((d) => d.status !== "recebido" && !isNa(d) && !d.optional);
  const pick = (k) => { setPickKey(k); setTimeout(() => fileRef.current?.click(), 0); };
  const upload = async (e) => {
    const f = e.target.files?.[0]; e.target.value = "";
    if (!f || !pickKey) return;
    try { await api.post(`/processes/${pid}/documents/${pickKey}/upload`, await makeForm([["file", f]])); toast.success("Ficheiro carregado"); onChange(); }
    catch (err) { toast.error(apiErr(err.response?.data?.detail) || "Falha no carregamento"); }
  };
  return (
    <div className="px-6 pb-4" data-testid="archive-zone">
      <div className="text-sm text-slate-500 pb-3 border-b border-slate-100" data-testid="archive-count">{kept.length} documento{kept.length === 1 ? "" : "s"} no arquivo</div>
      {kept.map((d) => (
        <div key={d.key} className="flex items-center gap-3 py-3 border-b border-slate-100" data-testid={`archive-doc-${d.key}`}>
          {d.verdict === "validado" ? <Check size={16} strokeWidth={2.75} className="text-[#15803D] shrink-0" /> : <FileText size={16} className="text-slate-400 shrink-0" />}
          <span className="flex-1 min-w-0 text-[15px] navy-text truncate">{label(d)}</span>
          <span className="text-sm text-slate-500">{d.verdict === "validado" ? "Verificado" : "Recebido"}</span>
          {d.file_id && <a href={`${API}/files/${d.file_id}`} target="_blank" rel="noreferrer" className="text-sm font-semibold navy-text hover:underline" data-testid={`archive-open-${d.key}`}>Abrir ficheiro</a>}
        </div>
      ))}
      {absent.map((d) => (
        <div key={d.key} className="flex items-center gap-3 py-3 border-b border-slate-100 text-slate-400" data-testid={`archive-absent-${d.key}`}>
          <span className="w-4 shrink-0" />
          <span className="flex-1 min-w-0 text-[15px] truncate">{label(d)}</span>
          <span className="text-sm">Não ficou no arquivo</span>
          {!ro && <button onClick={() => pick(d.key)} className="text-sm font-semibold text-slate-500 hover:text-slate-800 underline underline-offset-2" data-testid={`archive-upload-${d.key}`}>Carregar</button>}
        </div>
      ))}
      <input ref={fileRef} type="file" className="hidden" onChange={upload} accept="application/pdf,image/*" />
    </div>
  );
}
